<div class="mibarra w-100 mx-0 my-2"  >
      <div class="">
            <div class="mx-0 px-0 col-md-12 justify-content-start">
                  <div class="d-flex justify-content-between align-items-center">
                        <div class="step-text">
                              <strong class="d-none d-sm-inline">Paso {{activeStep+1}} de 4: </strong>
                              <span
                                    [ngClass]="{'font-weight-bold': isMobile()}">{{getCurrentSteps()[activeStep]}}</span>
                        </div>
                        <div *ngIf="activeStep+1 !== 4" class="next-stop-text">
                              Siguiente: {{isMobile() ? nextStepMovil[activeStep] : nextStep[activeStep]}}
                        </div>
                  </div>
                  <div class="container-fluid p-2 align-items-center">
                        <div class="d-flex justify-content-around">
                              <span *ngFor="let step of [1, 2, 3, 4]; let i = index"
                                    [ngClass]="{'bg-custom': i < activeStep, 'bg-custom-actual': i === activeStep, 'bg-custom-success': i > activeStep}"
                                    class="bg-success w-25 rounded mt-auto mb-auto me-1 ms-1 d-flex justify-content-center align-items-center"
                                    style="height: 0.3rem">
                                    <img *ngIf="i === activeStep" src="./assets/img/motico.png" alt="Cheque"
                                          class="motico-border" style="width: 20px; height: 20px">
                              </span>
                        </div>
                  </div>
            </div>
      </div>
</div>